import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "shadow rounded-sm flex flex-row justify-between items-center p-2 bg-white my-2 border-color"
};
const _hoisted_2 = {
  class: "text-sm font-semibold"
};
const _hoisted_3 = {
  class: "text-xs"
};
const _hoisted_4 = {
  class: "text-gray-500 block"
};
import { pluralize } from '@/services/utils';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'EventCard',
  props: {
    event: {
      type: Object,
      required: true
    },
    isDisabling: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addEntry', 'dismiss'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleAddEntry = () => {
      emit('addEntry', props.event);
    };
    const handleDismiss = () => {
      emit('dismiss', props.event.externalId);
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.event.subject), 1), _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.event.startTime) + " - " + _toDisplayString(__props.event.endTime) + " ", 1), _createElementVNode("span", _hoisted_4, " (" + _toDisplayString(__props.event.hours) + " " + _toDisplayString(_unref(pluralize)(__props.event.hours, 'hour')) + ") ", 1)])]), _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row items-center gap-1", {
          'pr-2': __props.event.state === 'Saved'
        }])
      }, [_createVNode(LlSecondaryButton, {
        variant: "tonal",
        size: "small",
        color: "primary",
        disabled: __props.event.state === 'Saved',
        onClick: handleAddEntry
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.event.state == 'Saved' ? 'Added' : 'Add'), 1)]),
        _: 1
      }, 8, ["disabled"]), __props.event.state !== 'Saved' ? (_openBlock(), _createBlock(LlTooltip, {
        key: 0,
        text: "Dismiss this event"
      }, {
        activator: _withCtx(({
          props
        }) => [_createVNode(_component_v_icon, _mergeProps(props, {
          onClick: handleDismiss,
          color: "grey-lighten-1",
          "data-cy": "btn-dismiss-event",
          disabled: __props.isDisabling
        }), {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" mdi-close ", -1)]))]),
          _: 1
        }, 16, ["disabled"])]),
        _: 1
      })) : _createCommentVNode("", true)], 2)]);
    };
  }
};